
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"citationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Citation"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstAuthorSurname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"journalTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bookTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"publicationType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"citationId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"volume"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"year"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lpage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fpage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"publicationLocation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"authors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"citationAuthorFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pubMedId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"doi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"doiType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"issue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isbn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"volumeTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seriesTitle"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":299}};
    doc.loc.source = {"body":"fragment citationFragment on Citation {\n  firstAuthorSurname\n  journalTitle\n  bookTitle\n  publicationType\n  citationId\n  volume\n  year\n  lpage\n  fpage\n  publicationLocation\n  authors {\n    ...citationAuthorFragment\n  }\n  title\n  pubMedId\n  doi\n  doiType\n  issue\n  isbn\n  volumeTitle\n  seriesTitle\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["citationFragment"] = oneQuery(doc, "citationFragment");
        
